import styled from "styled-components";
import { Colors } from "configs";

export const HeroWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(135deg, #eafaf8 0%, #ffffff 55%, #f3fbf5 100%);

  /* decorative brand blobs */
  ::before,
  ::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    filter: blur(8px);
    opacity: 0.45;
    z-index: 0;
  }

  ::before {
    width: 520px;
    height: 520px;
    top: -180px;
    right: -120px;
    background: radial-gradient(circle at center, #b7e4e2 0%, rgba(183, 228, 226, 0) 70%);
  }

  ::after {
    width: 420px;
    height: 420px;
    bottom: -160px;
    left: -120px;
    background: radial-gradient(circle at center, #d5e4bf 0%, rgba(213, 228, 191, 0) 70%);
  }
`;

export const HeroInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  padding: 72px 8vw 96px 8vw;
  display: flex;
  align-items: center;
  gap: 56px;

  @media (max-width: 992px) {
    flex-direction: column;
    text-align: center;
    padding: 56px 6vw 72px 6vw;
    gap: 40px;
  }
`;

export const HeroContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 992px) {
    align-items: center;
  }
`;

export const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(0, 178, 169, 0.1);
  color: ${Colors.primary};
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 7px 14px;
  border-radius: 50px;
  margin-bottom: 24px;

  img {
    height: 18px;
    width: auto;
  }
`;

export const Title = styled.h1`
  font-family: "Montserrat", "Nunito", sans-serif;
  font-weight: 800;
  font-size: 3rem;
  line-height: 1.12;
  color: #1f3b39;
  margin: 0 0 20px 0;
  max-width: 580px;

  span {
    color: ${Colors.primary};
  }

  @media (max-width: 992px) {
    font-size: 2.3rem;
  }
`;

export const Subtitle = styled.p`
  font-family: "Montserrat", "Nunito", sans-serif;
  font-size: 1.18rem;
  line-height: 1.6;
  color: ${Colors.secondary};
  margin: 0 0 36px 0;
  max-width: 520px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    justify-content: center;
  }
`;

export const PrimaryButton = styled.button`
  background: ${Colors.primary};
  border: 2px solid ${Colors.primary};
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  padding: 11px 30px;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s all;
  box-shadow: 0 12px 24px -12px rgba(0, 178, 169, 0.7);

  :hover {
    background: #00c2b8;
    border-color: #00c2b8;
    transform: translateY(-2px);
    box-shadow: 0 16px 28px -12px rgba(0, 178, 169, 0.75);
  }
`;

export const GhostButton = styled.button`
  background: transparent;
  border: 2px solid ${Colors.primary};
  color: ${Colors.primary};
  font-weight: 700;
  font-size: 1rem;
  padding: 11px 26px;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s all;

  :hover {
    background: ${Colors.primary};
    color: #fff;
  }
`;

export const Stats = styled.div`
  display: flex;
  gap: 36px;
  margin-top: 48px;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    justify-content: center;
  }
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    font-family: "Montserrat", "Nunito", sans-serif;
    font-size: 1.7rem;
    font-weight: 800;
    color: #1f3b39;
    line-height: 1;
  }

  span {
    margin-top: 6px;
    font-size: 0.92rem;
    color: ${Colors.secondary};
  }
`;

export const HeroMedia = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const VideoCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 540px;
  border-radius: 22px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 30px 60px -20px rgba(0, 95, 90, 0.45);

  .player-wrapper {
    position: relative;
    padding-top: 56.25%;
  }

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
